module.exports = __webpack_public_path__ + "static/media/maps_screenshot.f64c1276.png";